<script lang="ts" setup>
	import {useConsignmentStore} from '@/store/consignment.store';
	import {
		isSameConsignment,
		isSameVarietyAndWeek,
		removeOrderLineFromShoppingCart,
		updateOrderLineAmount,
		updateOrderLineConsignment
	} from 'dummen-shared';
	import {computed} from 'vue';
	import {useI18n} from 'vue-i18n';
	import Multiselect from 'vue-multiselect';
	import type {ShoppingCartOrderLine} from 'dummen-shared/src/interfaces/order.line.type.ts';
	import {useShoppingCartStore} from '@/store/shoppingcart.store.ts';

	const props = defineProps<{
		orderLine: ShoppingCartOrderLine;
		isDisabled: boolean;
	}>();

	const {t} = useI18n();

	const shoppingCartStore = useShoppingCartStore();

	const consignmentStore = useConsignmentStore();

	const findOrderLineByConsignment = (consignment: string | null) => {
		return shoppingCartStore.getOrderLinesForWeek(props.orderLine.week, props.orderLine.year)
			.find((line) => isSameVarietyAndWeek(props.orderLine, line) && isSameConsignment(consignment, line.consignment));
	};

	const consignmentLabel = computed({
		get: () => {
			return props.orderLine.consignment ?? null;
		},

		set: (newConsignment) => {
			const existingOrderLine = findOrderLineByConsignment(newConsignment);

			// If an order line with the same consignment already exists,
			// we just update the amount and remove the current order line.
			if (existingOrderLine) {
				updateOrderLineAmount(existingOrderLine, existingOrderLine.amount + props.orderLine.amount);
				removeOrderLineFromShoppingCart(props.orderLine);
				return;
			}

			return updateOrderLineConsignment(props.orderLine, newConsignment);
		}
	});

	const addTag = (newConsignment: string) => {
		consignmentLabel.value = newConsignment;
		consignmentStore.addConsignment(newConsignment);
	};
</script>

<template>
	<form novalidate onsubmit="return false;">
		<multiselect v-model="consignmentLabel"
		             :deselect-label="t('shoppingcart.generic.deselectConsignment.text')"
		             :disabled="isDisabled"
		             :options="consignmentStore.consignments"
		             :placeholder="t('shoppingcart.generic.selectConsignment.text')"
		             :searchable="true"
		             :show-labels="true"
		             :taggable="true"
		             select-label=""
		             selected-label=""
		             @select="consignmentStore.moveConsignmentToTop($event);"
		             @tag="addTag" />
	</form>
</template>
